import React from "react";
import { useIntl } from "gatsby-plugin-intl";

const I18nWrapper = ({ children }) => {
  const { locale } = useIntl();
  const direction = locale === "ar" ? "rtl" : "ltr";

  return (
    <div className="ltr:font-body rtl:font-body-ar" dir={direction}>
      {children}
    </div>
  );
};

export default I18nWrapper;
